import { css } from 'styled-components';

const styles = css`
  .toggle-arrow {
    background: none;
    border: none;
    cursor: pointer;
    color: ${(props) => props.theme.colorPalette.gray[1600]};
    padding: 0px;
  }
  .error-container {
    margin: ${(props) => (props.pageView !== 'myBag' ? '16px 0 4px' : '16px 0')};
    background-color: #f3f3f3;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: ${(props) => (props.pageView !== 'myBag' ? '16px 0 4px' : '16px 2px 0 2px')};
    }
  }

  .error-inner-container {
    padding: 12px;

    border-radius: 10px;
    background: white;
    ${(props) =>
      props.pageView !== 'myBag'
        ? `border: 1px solid ${props.theme.colors.NOTIFICATION.ERROR};  border-left-width: 6px;`
        : `border-left: 6px solid ${props.theme.colors.NOTIFICATION.ERROR};`};

    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 16px 18px;
    }
  }

  .error-header-arrow-container {
    display: flex;
    justify-content: space-between;
  }

  .error-subheader-container {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.3s ease;
  }

  .error-subheader-container.expanded {
    max-height: 200px;
    opacity: 1;
  }

  .error-subheader-container.collapsed {
    max-height: 0;
    opacity: 0;
  }

  .error-subheader-text-msg {
    line-height: 150%;
    padding-top: 6px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-top: 8px;
    }
  }

  .error-subheader-text-msg-container {
    display: flex;
    padding-top: 6px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-top: 8px;
    }
  }

  .price-drop-notification-view-items {
    text-decoration: underline;
    text-underline-offset: 1px;
    cursor: pointer;
    color: #005d95;
  }
  .product-price {
    color: #c8102e;
    margin-left: 4px;
  }

  .error-header-text-msg {
    line-height: 150%;
  }

  .removeErrorMessage {
    text-decoration: underline;
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    cursor: pointer;
    color: #005d95;
  }
`;

export default styles;
